/* global swal  angular*/
import './style.less';
import addActivityTemplate from 'modals/addActivity/template.html';
import addActivityController from 'modals/addActivity/index';

export default function($log, $uibModal) {
  'ngInject';

  const vm = this;

  vm.$onInit = activate;
  vm.activate = activate;

  vm.addActivity = type => {
    const activities = [...vm.event.blended.pre, ...vm.event.blended.post];
    $uibModal
      .open({
        template: addActivityTemplate,
        backdrop: 'static',
        size: 'lg',
        windowClass: 'modal',
        controller: addActivityController(activities)
      })
      .result.then(activitiesRaw => {
        const activities = activitiesRaw.map(({ uuid, name }) => ({
          name,
          uuid
        }));
        switch (type) {
          case 'pre':
            vm.event.blended.pre.push(...activities);
            break;
          case 'post':
            vm.event.blended.post.push(...activities);
            break;
        }
      })
      .catch(error => {
        if (error === 'backdrop click' || error === 'cancel') return;
        $log.error(error);
        throw error;
      });
  };

  vm.removeActivity = (type, index) => {
    switch (type) {
      case 'pre':
        vm.event.blended.pre.splice(index, 1);
        break;
      case 'post':
        delete vm.event.blended.splice(index, 1);
        break;
    }
  };

  function activate() {
    $log.debug('Blended Editor Component Activated');
    vm.event.blended = vm.event.blended || { pre: [], post: [] };
    vm.error = false;
    vm.loaded = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/blendedEditor/controller.js